const newPushPopover = require('../widgets/new-push-popover').default
const ReactDOM = require('react-dom')
const React = require('react')

/*
  You can find these properties' definitions in
  https://github.com/urbanairship/airship/blob/6e7b078/airship/templates/apps/includes/new_push_popover.html#L6
*/

const popoverWorkflowsEl = document.querySelector('.create-new-push-button')
if (popoverWorkflowsEl && popoverWorkflowsEl instanceof HTMLElement) {
  ReactDOM.render(
    React.createElement(newPushPopover, {
      hasPComposerAccess: popoverWorkflowsEl.hasAttribute(
        'data-has-pcomposer-access'
      ),
      hasExperimentsAccess: popoverWorkflowsEl.hasAttribute(
        'data-has-experiments'
      ),
      hasAppleNews: popoverWorkflowsEl.hasAttribute('data-has-apple-news'),
      hasJourneys: popoverWorkflowsEl.hasAttribute('data-has-journeys'),
      hasTriggersTag: popoverWorkflowsEl.hasAttribute('data-has-triggers-tag'),
      hasInAppAutomation: popoverWorkflowsEl.hasAttribute(
        'data-has-in-app-automation'
      ),
      hasTemplates: popoverWorkflowsEl.hasAttribute('data-has-templates'),
      hasScene: popoverWorkflowsEl.hasAttribute('data-has-scene'),
      hasSurvey: popoverWorkflowsEl.hasAttribute('data-has-survey'),
      createMessageUrl: popoverWorkflowsEl.getAttribute(
        'data-create-message-url'
      ),
      createExperimentUrl: popoverWorkflowsEl.getAttribute(
        'data-create-experiment-url'
      ),
      createAppleNewsUrl: popoverWorkflowsEl.getAttribute(
        'data-create-apple-news-url'
      ),
      createAutomatedUrl: popoverWorkflowsEl.getAttribute(
        'data-create-automated-url'
      ),
      createZoltarUrl: popoverWorkflowsEl.getAttribute(
        'data-create-zoltar-url'
      ),
      createSceneUrl: popoverWorkflowsEl.getAttribute(
        'data-create-app-tour-url'
      ),
      createAppSurveyUrl: popoverWorkflowsEl.getAttribute(
        'data-create-app-survey-url'
      ),
      createAppExperienceUrl: popoverWorkflowsEl.getAttribute(
        'data-create-app-experience-url'
      ),
      createTemplatesUrl: popoverWorkflowsEl.getAttribute(
        'data-create-templates-url'
      ),
      createJourneyModalOpenUrl: popoverWorkflowsEl.getAttribute(
        'data-create-journey-modal-open-url'
      ),
    }),
    popoverWorkflowsEl
  )
}
